import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { OuterSlideoutStyle } from './LegacyStyles';
import { LegacyOrder } from '../../types';
import DocumentsSlideout from './DocumentsSlideout';
import NamesSlideout from './NamesSlideout';
import PropertiesSlideout from './PropertiesSlideout';
import TopBarSlideout from './TopBarSlideout';

interface Props {
  legacyOrderId: number;
  onHideClick: () => void;
  width: number;
}

const LegacyOrderDetailsSlideout = (props: Props) => {
  const [legacyOrder, setLegacyOrder] = useState<LegacyOrder>({
    id: 0,
    titleNumber: '',
    hdsNumber: '',
    receivedDate: new Date(),
    status: '',
    clientId: 0,
    clientName: '',
    properties: [],
    searches: [],
    owners: [],
    documents: [],
  });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const getOrder = async () => {
      const { data } = await axios.get(
        `/api/clientOrder/getLegacyOrder?orderId=${props.legacyOrderId}`
      );
      setLegacyOrder(data);
    };
    if (props.legacyOrderId > 0) {
      getOrder().then(() => setLoading(false));
    }
  }, [props.legacyOrderId]);

  return (
    <OuterSlideoutStyle width={props.width}>
      <TopBarSlideout
        legacyOrder={legacyOrder}
        onHideClick={() => props.onHideClick()}
      />
      <DocumentsSlideout legacyOrder={legacyOrder} />
      <PropertiesSlideout legacyOrder={legacyOrder} />
      <NamesSlideout legacyOrder={legacyOrder} />
    </OuterSlideoutStyle>
  );
};
export default LegacyOrderDetailsSlideout;
